// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    Elements,
} from '@stripe/react-stripe-js'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    useHistory,
    useLocation,
} from 'react-router-dom'

// components
import {
    AlertSite,
} from 'components'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    ButtonHelper810Site,
    EditBlockSite,
    TemplateBlock797InputSite,
    TemplateBlock797LocationSite,
    TemplateBlock797PhoneNumberSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template810SiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
    parseQuerySite,
} from 'services'

// props
type TemplateBlock810SiteProps = {
    blockId: string
    content: Template810SiteSerializer | undefined
    isEditHovered: boolean
    isInComponent?: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock810Site: React.FC<TemplateBlock810SiteProps> = React.memo(({
    blockId,
    content,
    isEditHovered,
    isInComponent,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const reduxCacheSiteportfoliocurrencyiso_code = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.currency?.iso_code)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    const [amount, setAmount] = useState<number>(0)
    const [amountError, setAmountError] = useState<string>()
    const [currency, setCurrency] = useState<string>(reduxCacheSiteportfoliocurrencyiso_code || 'EUR')
    const [isRecurent, setIsRecurent] = useState(false)
    const [dynamicFormData, setDynamicFormData] = useState<{ [key: string]: any }>({})
    const [dynamicFormErrors, setDynamicFormErrors] = useState<{ [key: string]: string }>({})
    const [stylesNew, setStylesNew] = useState<{
        amountChoiceStyles: CustomCSSProperties | undefined,
        block1Styles: CustomCSSProperties | undefined,
        block2Styles: CustomCSSProperties | undefined,
        buttonStyles: CustomCSSProperties | undefined,
        freeAmountInputStyles: CustomCSSProperties | undefined,
        freeAmountLabelStyles: CustomCSSProperties | undefined,
        infosInputStyles: CustomCSSProperties | undefined,
        infosLabelStyles: CustomCSSProperties | undefined,
        mainStyles: CustomCSSProperties | undefined,
        periodStyles: CustomCSSProperties | undefined,
        realCostTextStyles: CustomCSSProperties | undefined,
        secureTextStyles: CustomCSSProperties | undefined,
        titleStyles: CustomCSSProperties | undefined,
        // @ts-ignore
    } | undefined>(applyStyles())

    useEffect(() => {
        const tempStyles = applyStyles()
        // @ts-ignore
        setStylesNew(tempStyles)

    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    useEffect(() => {
        if (content?.data_json?.isRecurringOnly) {
            setIsRecurent(true)
        }
    }, [content?.data_json?.isRecurringOnly])

    function applyStyles() {
        try {
            const aStyles = getStylesNew(reduxModalSite, styles, stylesEdit)
            return {
                amountChoiceStyles: {
                    background: aStyles?.donationAmountChoiceBackground,
                    borderColor: aStyles?.donationAmountChoiceBorderColor,
                    borderRadius: aStyles?.donationAmountChoiceBorderRadius,
                    borderStyle: aStyles?.donationAmountChoiceBorderStyle,
                    borderWidth: aStyles?.donationAmountChoiceBorderWidth,
                    color: aStyles?.donationAmountChoiceColor,
                    fontSize: aStyles?.donationAmountChoiceFontSize,
                    fontWeight: aStyles?.donationAmountChoiceFontWeight,
                    hoverBorderColor: aStyles?.donationAmountChoiceHoverBorderColor,
                    padding: aStyles?.donationAmountChoicePadding,
                },
                block1Styles: {
                    background: aStyles?.donationBlock1Background,
                    borderRadius: aStyles?.donationBlock1BorderRadius,
                    padding: aStyles?.donationBlock1Padding,
                },
                block2Styles: {
                    background: aStyles?.donationBlock2Background,
                    borderRadius: aStyles?.donationBlock2BorderRadius,
                    padding: aStyles?.donationBlock2Padding,
                },
                buttonStyles: {
                    buttonBackground: aStyles?.buttonBackground,
                    buttonBorderColor: aStyles?.buttonBorderColor,
                    buttonHoverBackground: aStyles?.buttonHoverBackground,
                    buttonHoverBorderColor: aStyles?.buttonHoverBorderColor,
                    buttonHoverTextColor: aStyles?.buttonHoverTextColor,
                    buttonTextColor: aStyles?.buttonTextColor,
                },
                freeAmountInputStyles: {
                    background: aStyles?.donationFreeAmountInputBackground,
                    borderColor: aStyles?.donationFreeAmountInputBorderColor,
                    borderRadius: aStyles?.donationFreeAmountInputBorderRadius,
                    borderStyle: aStyles?.donationFreeAmountInputBorderStyle,
                    borderWidth: aStyles?.donationFreeAmountInputBorderWidth,
                    color: aStyles?.donationFreeAmountInputColor,
                    fontFamily: aStyles?.donationFreeAmountInputFontFamily,
                    padding: aStyles?.donationFreeAmountInputPadding,
                },
                freeAmountLabelStyles: {
                    color: aStyles?.donationFreeAmountLabelColor,
                    fontFamily: aStyles?.donationFreeAmountLabelFontFamily,
                    fontSize: aStyles?.donationFreeAmountLabelFontSize,
                    fontWeight: aStyles?.donationFreeAmountLabelFontWeight,
                },
                infosInputStyles: {
                    background: aStyles?.donationInfosInputBackground,
                    borderColor: aStyles?.donationInfosInputBorderColor,
                    borderRadius: aStyles?.donationInfosInputBorderRadius,
                    borderStyle: aStyles?.donationInfosInputBorderStyle,
                    borderWidth: aStyles?.donationInfosInputBorderWidth,
                    color: aStyles?.donationInfosInputColor,
                    fontFamily: aStyles?.donationInfosInputFontFamily,
                    padding: aStyles?.donationInfosInputPadding,
                },
                infosLabelStyles: {
                    color: aStyles?.donationInfosLabelColor,
                    fontFamily: aStyles?.donationInfosLabelFontFamily,
                    fontSize: aStyles?.donationInfosLabelFontSize,
                    fontWeight: aStyles?.donationInfosLabelFontWeight,
                },
                mainStyles: {
                    colorMode: aStyles?.colorMode,
                },
                periodStyles: {
                    color: aStyles?.donationPeriodColor,
                    fontFamily: aStyles?.donationPeriodFontFamily,
                    fontSize: aStyles?.donationPeriodFontSize,
                    fontWeight: aStyles?.donationPeriodFontWeight,
                    hoverTextDecorationColor: aStyles?.donationPeriodHoverTextDecorationColor,
                    textDecorationColor: aStyles?.donationPeriodTextDecorationColor,
                    textDecorationLine: aStyles?.donationPeriodTextDecorationLine,
                    textDecorationThickness: aStyles?.donationPeriodTextDecorationThickness,
                    textTransform: aStyles?.donationPeriodTextTransform,
                    textUnderlineOffset: aStyles?.donationPeriodTextUnderlineOffset,
                },
                realCostTextStyles: {
                    color: aStyles?.donationRealCostTextColor,
                    fontSize: aStyles?.donationRealCostTextFontSize,
                    fontWeight: aStyles?.donationRealCostTextFontWeight,
                    letterSpacing: aStyles?.donationRealCostTextLetterSpacing,
                    lineHeight: aStyles?.donationRealCostTextLineHeight,
                    padding: aStyles?.donationRealCostTextPadding,
                },
                secureTextStyles: {
                    color: aStyles?.donationSecureTextColor,
                    fontSize: aStyles?.donationSecureTextFontSize,
                    fontWeight: aStyles?.donationSecureTextFontWeight,
                    letterSpacing: aStyles?.donationSecureTextLetterSpacing,
                    lineHeight: aStyles?.donationSecureTextLineHeight,
                    padding: aStyles?.donationSecureTextPadding,
                },
                titleStyles: {
                    color: aStyles?.donationTitleColor,
                    fontFamily: aStyles?.donationTitleFontFamily,
                    fontSize: aStyles?.donationTitleFontSize,
                    fontWeight: aStyles?.donationTitleFontWeight,
                    textTransform: aStyles?.donationTitleTextTransform,
                },
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'applyStyles',
            ))
        }
    }

    function handleAmountChange(value: any) {
        try {
            const numericValue = Number(value)
            const minimumAmount = content?.data_json?.minimumAmount ? Number(content?.data_json?.minimumAmount) : 0

            if (numericValue < minimumAmount && numericValue > 0) {
                setAmountError(`Le montant minimum est de ${minimumAmount}€`)
            } else {
                setAmountError('')
            }

            setAmount(value)
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'handleAmountChange',
            ))
        }
    }

    function handleDynamicFormFieldChange(fieldName: string, value: any) {
        try {
            setDynamicFormData(prev => ({
                ...prev,
                [fieldName]: value
            }))
            setDynamicFormErrors(prev => ({
                ...prev,
                [fieldName]: ''
            }))
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'handleDynamicFormFieldChange',
            ))
        }
    }

    const formFields = content?.form_fields?.length! > 0 ? content?.form_fields : [
        {
            'id': 0,
            'label': reduxText[8744],
            'name': 'first_name',
            'field_type': 'text' as const,
            'required': true,
        },
        {
            'id': 1,
            'label': reduxText[8745],
            'name': 'last_name',
            'field_type': 'text' as const,
            'required': true,
        },
        {
            'id': 2,
            'label': reduxText[8746],
            'name': 'email',
            'field_type': 'email' as const,
            'required': true,
        },
    ]

    const amountChoices = content?.data_json?.amountChoices?.split(',').map((amount: string) => Number(amount)) || []
    const currenciesArray = content?.data_json?.currencies ? JSON.parse(content?.data_json?.currencies) : [{ 'code': 'EUR', 'symbol': '€' }]

    return (
        <>
            <style>
                {`
                        .t-810-period-choice {
                            text-decoration-color: transparent;
                            &:hover,
                            &.active {
                                text-decoration-color: ${stylesNew?.periodStyles?.hoverTextDecorationColor || 'black'};
                            }
                        }
                        .t-810-block1-button {
                            border-color: transparent;
                            &:hover,
                            &.active {
                                border-color: ${stylesNew?.amountChoiceStyles?.hoverBorderColor || 'black'};
                            }
                        }
                        .t-810-button {
                            background: ${stylesNew?.buttonStyles?.buttonBackground || 'black'};
                            border-color: ${stylesNew?.buttonStyles?.buttonBorderColor || 'transparent'};
                            color: ${stylesNew?.buttonStyles?.buttonTextColor || 'white'};
                            &:hover {
                                background: ${stylesNew?.buttonStyles?.buttonHoverBackground || 'black'};
                                border-color: ${stylesNew?.buttonStyles?.buttonHoverBorderColor || 'transparent'};
                                color: ${stylesNew?.buttonStyles?.buttonHoverTextColor || 'white'};
                            }
                        }
                    `}
            </style>
            <div
                id={blockId}
                className={`template-block-810-new${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            >
                {parseQuerySite(location.search).success
                    ? (
                        <>
                            <AlertSite
                                buttons={[{ text: 'OK' }]}
                                isOpen
                                header={content?.success_message || reduxText[8519]}
                                // message={content?.success_message || reduxText[8519]}
                                onDidDismiss={() => history.replace({ pathname: location.pathname, search: '' })}
                            />
                        </>

                    ) : (
                        <React.Fragment>
                            {!content?.data_json?.isMembership && (
                                <div
                                    className={`t-810-block1 ${deviceType}`}
                                    style={stylesNew?.block1Styles}
                                >
                                    <div className={`t-810-block1-period ${deviceType}`}>
                                        {!content?.data_json?.isRecurringOnly && (
                                            <span
                                                className={`t-810-period-choice${!isRecurent ? ' active' : ''} ${deviceType}`}
                                                onClick={() => setIsRecurent(!isRecurent)}
                                                style={stylesNew?.periodStyles}
                                            >
                                                Ponctuel
                                            </span>
                                        )}
                                        <span
                                            className={`t-810-period-choice${isRecurent ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setIsRecurent(!isRecurent)}
                                            style={stylesNew?.periodStyles}
                                        >
                                            Mensuel
                                        </span>
                                    </div>
                                    {amountChoices.length > 0 && (
                                        <div className={`t-810-block1-amount-choices ${deviceType}`}>
                                            {amountChoices.map((amountChoice) => (
                                                <button
                                                    key={amountChoice}
                                                    className={`t-810-block1-button${(amount === amountChoice) ? ' active' : ''} ${deviceType}`}
                                                    onClick={() => handleAmountChange(amountChoice)}
                                                    style={stylesNew?.amountChoiceStyles}
                                                    type='button'
                                                >
                                                    {amountChoice}{currenciesArray.find((val: any) => val.code === currency)?.symbol}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                    <div className={`t-810-block1-custom-amount ${deviceType}`}>
                                        <span
                                            className={`t-810-label ${deviceType}`}
                                            style={stylesNew?.freeAmountLabelStyles}
                                        >
                                            Montant libre
                                        </span>
                                        <div className={`t-810-block1-input-wrapper ${deviceType}`}>
                                            <input
                                                className={`t-810-amount ${deviceType}`}
                                                min={content?.data_json?.minimumAmount ? Number(content?.data_json?.minimumAmount) : 0}
                                                name='amount'
                                                onChange={(e) => handleAmountChange(e.target.value)}
                                                style={stylesNew?.freeAmountInputStyles}
                                                tabIndex={1}
                                                type='number'
                                                value={amount}
                                            />
                                            <span className='t-810-currency-symbol'>{currency}</span>
                                            {dynamicFormErrors.amount && (
                                                <span className='t-810-error'>{dynamicFormErrors.amount}</span>
                                            )}
                                        </div>
                                        {currenciesArray.length > 1 && (
                                            <div className='t-810-currency-wrapper'>
                                                {currenciesArray.map((val: any) => (
                                                    <span
                                                        className={`t-810-currency-item${val.code === currency ? ' active' : ''} ${deviceType}`}
                                                        onClick={() => setCurrency(val.code)}
                                                    >
                                                        {val.code}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                        {(isRecurent || content?.data_json?.isRecurringOnly) && (
                                            <p
                                                className={`t-810-real-cost-text visible ${deviceType}`}
                                                style={stylesNew?.realCostTextStyles}
                                            >
                                                /{reduxText[8508]}
                                            </p>
                                        )}
                                        {amountError && (
                                            <span className='t-810-error'>{amountError}</span>
                                        )}
                                    </div>
                                    {currency === 'EUR' && (
                                        <p
                                            className={`t-810-real-cost-text${amount > 0 ? ' visible' : ''} ${deviceType}`}
                                            style={stylesNew?.realCostTextStyles}
                                        >
                                            Si vous êtes imposable, votre don ne vous coûte réellement que {Number(amount / 100 * 34).toFixed(2)}€ après réduction d'impôt.
                                        </p>
                                    )}
                                </div>
                            )}
                            <div
                                className={`t-810-block2 ${deviceType}`}
                                style={stylesNew?.block2Styles}
                            >
                                {!content?.data_json?.isMembership && (
                                    <span
                                        className={`t-810-title ${deviceType}`}
                                        style={stylesNew?.titleStyles}
                                    >
                                        {reduxText[11071]}
                                    </span>
                                )}
                                {formFields?.map((val, index) => {
                                    const fieldName = val.name!
                                    const fieldValue = dynamicFormData[fieldName]
                                    const fieldError = dynamicFormErrors[fieldName]

                                    if (val.field_type === 'text') {
                                        return (
                                            <React.Fragment key={val.id || index}>
                                                <span
                                                    className={`t-810-label ${deviceType}`}
                                                    style={stylesNew?.infosLabelStyles}
                                                >
                                                    {val.label}
                                                </span>
                                                <TemplateBlock797InputSite
                                                    blockId={blockId}
                                                    deviceType={deviceType}
                                                    formInputObj={val}
                                                    handleInputChange={handleDynamicFormFieldChange}
                                                    isEditHovered={isEditHovered}
                                                    reduxModalSite={reduxModalSite}
                                                    stylesNew={stylesNew?.infosInputStyles}
                                                    tabIndex={4 + index}
                                                    value={fieldValue}
                                                />
                                                {fieldError && (
                                                    <span className='t-810-error'>{fieldError}</span>
                                                )}
                                            </React.Fragment>
                                        )
                                    }
                                    if (val.field_type === 'email') {
                                        return (
                                            <React.Fragment key={val.id || index}>
                                                <span
                                                    className={`t-810-label ${deviceType}`}
                                                    style={stylesNew?.infosLabelStyles}
                                                >
                                                    {val.label}
                                                </span>
                                                <TemplateBlock797InputSite
                                                    blockId={blockId}
                                                    deviceType={deviceType}
                                                    formInputObj={val}
                                                    handleInputChange={handleDynamicFormFieldChange}
                                                    isEditHovered={isEditHovered}
                                                    reduxModalSite={reduxModalSite}
                                                    stylesNew={stylesNew?.infosInputStyles}
                                                    tabIndex={4 + index}
                                                    value={fieldValue}
                                                />
                                                {fieldError && (
                                                    <span className='t-810-error'>{fieldError}</span>
                                                )}
                                            </React.Fragment>
                                        )
                                    }
                                    if (val.field_type === 'phonenumber') {
                                        return (
                                            <React.Fragment key={val.id || index}>
                                                <span
                                                    className={`t-810-label ${deviceType}`}
                                                    style={stylesNew?.infosLabelStyles}
                                                >
                                                    {val.label}
                                                </span>
                                                <TemplateBlock797PhoneNumberSite
                                                    blockId={blockId}
                                                    deviceType={deviceType}
                                                    formInputObj={val}
                                                    handleInputChange={handleDynamicFormFieldChange}
                                                    isEditHovered={isEditHovered}
                                                    reduxModalSite={reduxModalSite}
                                                    stylesNew={stylesNew?.infosInputStyles}
                                                    tabIndex={4 + index}
                                                    value={fieldValue}
                                                />
                                                {fieldError && (
                                                    <span className='t-810-error'>{fieldError}</span>
                                                )}
                                            </React.Fragment>
                                        )
                                    }
                                    if (val.field_type === 'location') {
                                        return (
                                            <React.Fragment key={val.id || index}>
                                                <span
                                                    className={`t-810-label ${deviceType}`}
                                                    style={stylesNew?.infosLabelStyles}
                                                >
                                                    {val.label}
                                                </span>
                                                <TemplateBlock797LocationSite
                                                    blockId={blockId}
                                                    deviceType={deviceType}
                                                    formInputObj={val}
                                                    handleInputChange={handleDynamicFormFieldChange}
                                                    isEditHovered={isEditHovered}
                                                    reduxModalSite={reduxModalSite}
                                                    stylesNew={stylesNew?.infosInputStyles}
                                                    tabIndex={4 + index}
                                                    value={fieldValue}
                                                />
                                                {fieldError && (
                                                    <span className='t-810-error'>{fieldError}</span>
                                                )}
                                            </React.Fragment>
                                        )
                                    }
                                    return null
                                })}
                                <Elements stripe={reduxModalSite.stripePromise}>
                                    <ButtonHelper810Site
                                        amount={amount}
                                        buttonText={content?.button_text}
                                        currency={currency}
                                        isRecurent={isRecurent}
                                        membershipPriceId={content?.data_json?.isMembership ? content?.stripe_product_id : undefined}
                                        minimumAmount={content?.data_json?.minimumAmount ? Number(content?.data_json?.minimumAmount) : undefined}
                                        productId={content?.stripe_product_id}
                                        dynamicFormData={dynamicFormData}
                                        setDynamicFormErrors={setDynamicFormErrors}
                                        formFields={formFields}
                                    />
                                </Elements>
                                <span
                                    className={`t-810-secure ${deviceType}`}
                                    style={stylesNew?.secureTextStyles}
                                >
                                    {reduxText[8504]}
                                </span>
                            </div>
                        </React.Fragment>
                    )
                }
                <EditBlockSite
                    isInComponent={isInComponent}
                    mainParentId={mainParentId || object.id!}
                    object={object}
                    parentArray={parentArray}
                    parentStyles={parentStyles}
                />
            </div>
        </>
    )
})
